import React from 'react'
import Loading from "../components/common/Loading";
import switchStyles from "../styles/desktopMobileSwitch.module.css";
import dynamic from "next/dynamic";
import Head from "next/head";
import Einvoicing from '@/components/Einvoicing';

const eInvoicing = () => {
  return (
    <>
      <Head>
        <title>e Invoicing Software for SMBs in India with QueueBuster POS</title>
        <link rel="canonical" href="https://queuebuster.co/features/e-invoicing" />
        <link rel="alternate" href="https://queuebuster.co/features/e-invoicing" hrefLang="en-us" />
        <meta name="description" content="Optimize your invoicing process with QueueBuster POS's GST e Invoicing Softwate feature. Automate GST e Invoicing generation, reduce errors, and enhance efficiency." />
        <meta property="og:title" content="e Invoicing Software for SMBs in India with QueueBuster POS | GST e Invoicing Software" />
        <meta property="og:description" content="Effortlessly manage GST compliance with QueueBuster POS's e Invoicing feature. Automate GST invoice generation, reduce errors, and enhance efficiency. Discover our advanced GST e-invoicing solutions today." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/payment-og%2B(1)+(1).jpg" />
        <meta property="og:url" content="https://queuebuster.co/features/e-invoicing" />
      </Head>
      <Einvoicing />

    </>
  )
}

export default eInvoicing